/**
 * Work that belongs to the current API session gets a chance to finish or
 * clean up before that session changes workspace or ends. The server session
 * changes first in both flows, so cleanup must happen while it still applies.
 */
export type SessionChange = 'switch-workspace' | 'sign-out';

/** Resolves `false` to keep the current session. */
type SessionChangeGuard = (change: SessionChange) => Promise<boolean>;

const guards = new Set<SessionChangeGuard>();

export function registerSessionChangeGuard(guard: SessionChangeGuard): () => void {
  guards.add(guard);
  return () => { guards.delete(guard); };
}

/** Ask every registered guard in turn; the first refusal keeps the session. */
export async function approveSessionChange(change: SessionChange): Promise<boolean> {
  for (const guard of [...guards]) {
    if (!(await guard(change))) return false;
  }
  return true;
}

export class SessionChangeDeclinedError extends Error {
  constructor() {
    super('Uploads are still sending in this workspace, so the workspace was not switched.');
    this.name = 'SessionChangeDeclinedError';
  }
}
